import actions from './actions';
import * as getters from './getters';
import mutations from './mutations';

const state = () => ({
  progress: null,
});

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
